import { useCssVars, computed, toRef, resolveComponent, createBlock, openBlock, resolveDynamicComponent, unref, mergeProps, isRef, createSlots, withCtx, createVNode, normalizeClass, renderList, createElementVNode, createCommentVNode, toDisplayString, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import { VRadio, VCheckbox } from "vuetify/components";
import { useField } from "vee-validate";
import { isString } from "lodash-es";
import "moment";
import { uuid } from "../../utils/uuid.js";
import { useTheme } from "../../composables/useTheme.js";
/* empty css                  */
const _hoisted_1 = { class: "d-flex flex-nowrap align-center" };
const _sfc_main = {
  __name: "BanzaBoolean",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "checkbox"
    },
    value: {
      type: [String, Number, Boolean],
      default: void 0
    },
    selected: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: [String],
      default: ""
    },
    rules: {
      type: [String, Array],
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: null
    },
    hideDetails: {
      type: [String, Boolean],
      default: "auto"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    preset: {
      type: String,
      default: null
    },
    selectedIcon: {
      type: String,
      default: null
    },
    selectedDisabledIcon: {
      type: String,
      default: null
    },
    trueIcon: {
      type: String,
      default: null
    },
    trueDisabledIcon: {
      type: String,
      default: null
    },
    falseIcon: {
      type: String,
      default: null
    },
    falseDisabledIcon: {
      type: String,
      default: null
    },
    size: {
      type: [String, Number],
      default: null
    },
    align: {
      type: String,
      default: "center"
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "1f8c2b9f": __props.align
    }));
    const props = __props;
    const isRadio = computed(() => props.type === "radio");
    const {
      value: innerValue,
      handleChange,
      errors
    } = useField(
      () => props.name || uuid(),
      toRef(() => props.rules),
      {
        type: props.type,
        checkedValue: props.value !== void 0 ? props.value : true,
        uncheckedValue: false,
        syncVModel: true
      }
    );
    const fieldErrors = computed(
      () => props.errorMessages ? [].concat(props.errorMessages) : errors.value || []
    );
    const errorState = computed(() => props.error || fieldErrors.value.length > 0);
    const hideDetails = computed(
      () => props.hideDetails === "auto" ? fieldErrors.value.filter(isString).length === 0 : props.hideDetails
    );
    const handleClick = (e) => {
      if (props.readonly || props.disabled) {
        e.preventDefault();
        return;
      }
      handleChange(e);
    };
    const { attrs } = useTheme({
      componentKey: computed(
        () => isRadio.value ? "BanzaRadio" : "BanzaCheckbox"
      ),
      presetName: toRef(() => props.preset)
    });
    const selectedIcon = computed(
      () => {
        var _a, _b;
        return (props.disabled && (props.selectedDisabledIcon ?? ((_a = attrs.value) == null ? void 0 : _a.selectedDisabledIcon)) || props.selectedIcon || ((_b = attrs.value) == null ? void 0 : _b.selectedIcon)) ?? (isRadio.value ? "$radioOn" : "$checkboxIndeterminate");
      }
    );
    const trueIcon = computed(
      () => {
        var _a, _b;
        return (props.disabled && (props.trueDisabledIcon ?? ((_a = attrs.value) == null ? void 0 : _a.trueDisabledIcon)) || props.trueIcon || ((_b = attrs.value) == null ? void 0 : _b.trueIcon)) ?? (isRadio.value ? "$radioOn" : "$checkboxOn");
      }
    );
    const falseIcon = computed(
      () => {
        var _a, _b;
        return (props.disabled && (props.falseDisabledIcon ?? ((_a = attrs.value) == null ? void 0 : _a.falseDisabledIcon)) || props.falseIcon || ((_b = attrs.value) == null ? void 0 : _b.falseIcon)) ?? (isRadio.value ? "$radioOff" : "$checkboxOff");
      }
    );
    const size = computed(() => {
      var _a;
      return props.size ?? ((_a = attrs.value) == null ? void 0 : _a.size) ?? 24;
    });
    const icon = computed(() => {
      const isPlainSelected = !props.value && innerValue.value;
      const isSelectedInArray = props.value && Array.isArray(innerValue.value) && innerValue.value.includes(props.value);
      return isPlainSelected || isSelectedInArray ? props.selected ? selectedIcon.value : trueIcon.value : falseIcon.value;
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_tooltip = resolveComponent("b-tooltip");
      return openBlock(), createBlock(resolveDynamicComponent(unref(isRadio) ? unref(VRadio) : unref(VCheckbox)), mergeProps({
        class: "b-boolean",
        modelValue: unref(innerValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(innerValue) ? innerValue.value = $event : null),
        label: __props.label,
        error: unref(errorState),
        "error-messages": unref(fieldErrors),
        "hide-details": unref(hideDetails),
        readonly: __props.readonly,
        disabled: __props.disabled,
        value: __props.value
      }, unref(attrs)), createSlots({
        input: withCtx(() => [
          createVNode(_component_b_icon, {
            size: unref(size),
            class: normalizeClass({ "c-pointer": !__props.readonly }),
            icon: unref(icon),
            onClick: handleClick
          }, null, 8, ["size", "class", "icon"])
        ]),
        _: 2
      }, [
        !_ctx.$slots.label ? {
          name: "label",
          fn: withCtx(() => [
            createElementVNode("div", _hoisted_1, [
              createElementVNode("span", { onClick: handleClick }, toDisplayString(__props.label), 1),
              __props.tooltip && !__props.disabled ? (openBlock(), createBlock(_component_b_tooltip, {
                key: 0,
                tooltip: __props.tooltip,
                class: "ml-2"
              }, null, 8, ["tooltip"])) : createCommentVNode("", true)
            ])
          ]),
          key: "0"
        } : void 0,
        renderList(_ctx.$slots, (_, slotName) => {
          return {
            name: slotName,
            fn: withCtx((slotProps) => [
              renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
            ])
          };
        })
      ]), 1040, ["modelValue", "label", "error", "error-messages", "hide-details", "readonly", "disabled", "value"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
